import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rentRow"]

  toggle(event) {
    const realityId = event.currentTarget.dataset.realityId
    const row = this.rentRowTargets.find((el) => el.dataset.realityId === realityId)

    if (row) {
      const isExpanding = row.classList.contains("d-none")
      row.classList.toggle("d-none")

      const icon = event.currentTarget.querySelector(".material-symbols-outlined")
      if (icon) {
        icon.style.transform = isExpanding ? "rotate(180deg)" : "rotate(0deg)"
      }
    }
  }
}
